export const ClassName = {
  EMAIL_INPUT: `js-form-stock-email`,
  INPUT_ERROR: `input--error`,
  EMAIL_INPUT_HIDE: `subscribe-promo__input--hide`,
  DIGITS_WRAPPER_HIDE: `subscribe-promo__code-wrapper--hide`,
  DIGITS_WRAPPER_ERROR: `subscribe-promo__code-wrapper--error`,
  FORM_HIDE: `subscribe-promo__form--hide`,
  TEXT_CONTENT_SEND_CODE: `subscribe-promo__text-content--code`,
  TEXT_CONTENT_HIDE: `subscribe-promo__text-content--hide`,
  SEND_CODE: `subscribe-promo--code`,
  TITLE_ERROR: `subscribe-promo__title--error`,
  TITLE_SUCCESS: `subscribe-promo__title--success`,
}

export const Selector = {
  EMAIL_INPUT: `.${ClassName.EMAIL_INPUT}`,
  FORM: `.js-form-stock`,
  DIGITS_WRAPPER: `.js-stock-code-wrapper`,
  FORM_WRAPPER: `.js-form-stock-wrapper`,
  SUBMIT_BUTTON: `.js-submit`,
  SUBMIT_BUTTON_TEXT: `.js-button-text`,
  TEXT_CONTENT_WRAPPER: `.js-form-stock-content`,
  TITLE: `.js-form-stock-title`,
  TEXT: `.js-form-stock-text`,
}

export const ButtonTitle = {
  SEND_EMAIL: `Подписаться`,
  SEND_CODE: `Подтвердить`,
  CODE_ERROR: `Подтвердить повторно`
}

export const FormStatus = {
  SEND_EMAIL: `SEND_EMAIL`,
  SEND_CODE: `SEND_CODE`,
  CODE_ERROR: `CODE_ERROR`
}

export const CodeTextContent = {
  TITLE: `Подтвердите адрес электронной почты`,
  TEXT: `Мы отправили письмо с кодом подтверждения на указанный адрес.`,
  ERROR_TITLE: `Ошибка`,
  SERVER_ERROR_TEXT: `Попробуйте снова чуть позже`,
  WRONG_CODE: `Код введен не верно`,
  SUCCESS_TITLE: `Спасибо за подписку!`,
  SUCCESS_TEXT: `Готово! Теперь вы в курсе новых акций`
}
